import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { Search } from '../models/search.model';
import { ServiceInstance, ServiceInstanceTotals } from '../models/serviceinstance.model';
import { BaseService } from './base.service';

export class ServiceInstanceService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	serviceBalance(search: Search): Promise<ServiceInstanceTotals> {
		return this.mapResponse<ServiceInstanceTotals>(this.http.post('/ws/serviceinstance/balance', classToPlain(search)), ServiceInstanceTotals);
	}

	action(servicesid: (number | undefined)[], action: string) {
		return this.mapResponse<ServiceInstance>(this.http.post(`/ws/serviceinstance/action/${action}`, servicesid), ServiceInstance);
	}

	deleteAll(ids: (number | undefined)[]): Promise<any> {
		return this.http.post('ws/serviceinstance/deletelist', ids);
	}

	deletePeriodicAll(ids: (number | undefined)[]): Promise<any> {
		return this.http.post('ws/periodicservice/deletelist', ids);
	}
}